// extracted by mini-css-extract-plugin
export default {"cls1":"JfRg2a4q2tudXiJgFXcO","cls2":"CrowS4Q3Y0wYK44rdIcY JfRg2a4q2tudXiJgFXcO","filled":"hEiQyMbMyHLkB9JGrKlQ","isError":"UL9McyfezwSqQjbbyu6J"};